import type { ProductSelectOption } from '../types';

interface ProductNameItemProps {
    product: ProductSelectOption;
}

const ProductNameItem = ({ product }: ProductNameItemProps) => {
    const titleMeta = [product.article, product.vendor].filter(Boolean).join(' · ');

    return (
        <div className="min-w-0 overflow-hidden flex-grow-1">
            <h6 className="mb-1 text-truncate" title={product.label}>
                {product.label || '—'}
            </h6>
            {titleMeta ? (
                <p className="f-12 mb-0 text-truncate" title={titleMeta}>
                    {product.article ? <span className="text-muted">{product.article}</span> : null}
                    {product.article && product.vendor ? <span className="text-muted"> · </span> : null}
                    {product.vendor ? <span className="text-primary">{product.vendor}</span> : null}
                </p>
            ) : null}
        </div>
    );
};

export default ProductNameItem;
